let currentLanguage = 'en';

export const setLanguage = (language) => {
  currentLanguage = language;
};

export const getLanguage = () => currentLanguage;
